import styled from "styled-components";
import { Flex, Text, Image } from "rebass/styled-components";

import { useAnalyticsContext } from "MVVM/Hooks/useAnalyticsContext";
import teemo from "MVVM/Assets/EmbeddablePlaylist/EmptyState/teemo.png";
import profileBg from "MVVM/Assets/EmbeddablePlaylist/EmptyState/profileBg.png";

export const NextUpEmptyState = () => {
  const { track } = useAnalyticsContext();
  const currentUrlParams = new URLSearchParams(window.location.search);
  const platform = currentUrlParams.get("platform") || "unknown";
  const puuid = currentUrlParams.get("puuid");
  const profileIconId = currentUrlParams.get("profileIconId");
  const riotID = currentUrlParams.get("riotID");
  const displayName = riotID ? decodeURIComponent(riotID) : false;
  const playerGameIdentifier = puuid || false;
  const ajs_aid = window.rudderanalytics.getAnonymousId();
  const targetUrl = playerGameIdentifier
    ? `https://allstar.gg/match-history?playerSearchIdentifier=${playerGameIdentifier}&skipLandingPage=true&ajs_aid=${ajs_aid}&utm_source=${platform}`
    : `https://www1.allstar.gg?ajs_aid=${ajs_aid}&utm_source=${platform}`;
  const logoSrc =
    profileIconId && profileIconId !== "undefined"
      ? `${process.env.REACT_APP_S3_CLIP_BUCKET}/static/web/lol/summoner_icons/${profileIconId}.png`
      : teemo;

  return (
    <StyledEmptyStateContainer>
      <StyledContentContainer
        flexDirection="column"
        justifyContent="flex-start"
      >
        <StyledEmptyStateLogo src={logoSrc} $isRounded={!!profileIconId} />
        <StyledMainCopy>
          {displayName ? `${displayName}'s ` : ""}Clips Pending
        </StyledMainCopy>
        <StyledSubCopy>
          Check back soon to watch them right here...
        </StyledSubCopy>
      </StyledContentContainer>
      <StyledBottomBar>
        <StyledBottomBarText>
          Want to create your own highlights 100% FREE, with 0% FPS drop?
        </StyledBottomBarText>
        <StyledCreateNowButton
          onClick={() => {
            track("Button - Click", {
              locationIdentifier: "nextup_empty_state_visit_allstar",
              location: "embeddable_playlist",
              platform,
            });
            window.open(targetUrl, "_blank");
          }}
        >
          Create Now
        </StyledCreateNowButton>
      </StyledBottomBar>
    </StyledEmptyStateContainer>
  );
};

const StyledEmptyStateLogo = styled(Image)<{ $isRounded?: boolean }>`
  height: auto;
  width: 64px;
  border-radius: ${({ $isRounded }) => ($isRounded ? "50%" : "0")};
`;

const StyledMainCopy = styled(Text)`
  color: ice;
  font-size: 14px;
  font-weight: 700;
  text-align: center;
`;

const StyledSubCopy = styled(Text)`
  color: #cddcfe;
  font-size: 12px;
  font-weight: 500;
  text-align: center;
`;

const StyledContentContainer = styled(Flex)`
  align-items: center;
  gap: 8px;
  padding: 26px 16px 60px 16px;
  position: relative;
  width: 100%;
  z-index: 1;
`;

const StyledBottomBar = styled(Flex)`
  align-items: center;
  background-color: #070720;
  bottom: 0;
  height: 44px;
  justify-content: space-between;
  padding: 0 8px;
  position: absolute;
  width: 100%;
  z-index: 1;
`;

const StyledBottomBarText = styled(Text)`
  color: white;
  font-size: 12px;
  font-weight: 500;
`;

const StyledCreateNowButton = styled.button`
  animation: pulse 1s infinite;
  background-color: #3273fa;
  border: none;
  border-radius: 2px;
  color: white;
  cursor: pointer;
  font-size: 11px;
  font-weight: 600;
  height: 28px;
  margin-left: 8px;
  opacity: 1;
  padding: 0 10px;
  white-space: nowrap;
  width: 100px;

  &:hover {
    animation: none;
    background-color: rgb(41, 99, 218);
  }

  @keyframes pulse {
    0% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.05);
    }
    100% {
      transform: scale(1);
    }
  }
`;

const StyledEmptyStateContainer = styled(Flex)`
  background: url(${profileBg});
  background-position: center;
  background-size: cover;
  height: 100%;
  position: relative;
  width: 100%;

  &::before {
    background-color: rgba(37, 37, 75, 0.8);
    bottom: 0;
    content: "";
    left: 0;
    pointer-events: none;
    position: absolute;
    right: 0;
    top: 0;
  }
`;
